import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AccountFeaturesService } from '../account-features/account-features.service';

@Injectable()
export class AccountFeatureGuard  {
  constructor(private accountFeaturesService: AccountFeaturesService) {}

  async canActivate(route: ActivatedRouteSnapshot, _: RouterStateSnapshot): Promise<boolean> {
    if (!route.data.requiresFeature) {
      return true;
    }

    return firstValueFrom(this.accountFeaturesService.doesAccountHaveFeature(route.data.requiresFeature));
  }
}
